import { Configuration } from "@environment/startUp";
let APICONSTANT: any = {};

APICONSTANT = {
  DISTRICTLIST: Configuration.CrmUrl + "/api/District/GetDistrictForSignup",
  STATELIST:Configuration.CrmUrl + "/api/State",
  SCHOOLLIST:Configuration.CrmUrl+"/api/School/GetSchoolNames",
  ELEMENTARYSCHOOLLIST:Configuration.CrmUrl+"/api/School/GetElementrySchools",
  INSERTREQUESTMOREINFO:Configuration.CrmUrl+"/api/Lead",
  ROLELIST:Configuration.CrmUrl+"/api/Lead/GetLeadRoles",
  USERREGISTER:Configuration.StudentUrl+"/api/Users/UserRegister",
  ADDSUBSCRIPTION:Configuration.StudentUrl+"/api/Subscription/UserRegisterSubscription",
  GET_CLIENT_SECRET:Configuration.StudentUrl+"/api/Subscription/GetIntent",
  ADD_SCHOOL_DISTRICT_QUOTE:Configuration.StudentUrl+"/api/WebsiteQuote",
  CHECK_EMAIL_EXISTS:Configuration.StudentUrl+"/api/Users/EmailExists",
  MANAGE_EXISTING_USER:Configuration.StudentUrl+"/api/Users/ExistingUser",
  GET_SCHOOL_LICENSE:Configuration.CrmUrl+"/api/School/GetSchoolLicense",
  GET_SCHOOL_PAID_ACCOUNT:Configuration.StudentUrl+"/api/Subscription/GetSchoolPaidAccount",
  Is_EMAIL_VERIFIED:Configuration.CrmUrl+"/api/UserAccounts/IsEmailVerified",
  ResendEmail:Configuration.StudentUrl+"/api/Users/ResendEmail",
  GET_PRODUCT_STATE_GRADES: Configuration.StudentUrl+"/api/Users/GetProductStateGrades",
  GIVE_ACCESS_TO_PRODUCT: Configuration.StudentUrl+"/api/Users/GiveAccessToProduct",
  ADDPARENTSUBSCRIPTION:Configuration.StudentUrl+"/api/Subscription/AddParentSubscription",
  CHECK_DUPLICATE_EMAIL:Configuration.StudentUrl+"/api/Users/IsDuplicateEmail",
}

export default APICONSTANT;
